// WP-07 — SPA entry point. Replaces the WP-01 static stub (LLD-05).
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./app/app";
import { sessionStore } from "./auth/session-store";
import { applyCanonicalBranding } from "./theme/branding";
import "./theme/tokens.css";

// WP-22 (D-F5): re-apply the persisted tenant's branding on cold reload (the
// zustand persist store hydrates synchronously from localStorage). No network —
// the next login refreshes it. Un-branded tenants keep the Steier defaults.
applyCanonicalBranding(sessionStore.getState().org?.branding);

const container = document.getElementById("root");
if (!container) {
  throw new Error("office-web: #root container missing from index.html");
}

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
